export default {
    upcomingStopNoPrediction: 'No prediction data available',
    upcomingStopNoInfo: 'No upcoming stop information available',
    pastStopNotInfo: 'No past stop information available',
    pastVehicleNotInfo: 'No past vehicle information available',
    upcomingVehicleNoInfo: 'No upcoming vehicle information available',
    pidInformationNoInfo: 'No Services Due ',
};
